<ion-item class="question-item time-item" [formGroup]="form">
  <div class="date-trigger-button"
    [class.emptyDateTimeStyle]="form.get(this.inputName).value === '' || form.get(this.inputName).value === undefined || form.get(this.inputName).value === null"
    (click)="openPicker()">
    <span *ngIf="displayValue">{{ displayValue }}</span>
    <span *ngIf="!displayValue">Select time</span>
  </div>
  <ion-modal [isOpen]="isPickerOpen" [backdropDismiss]="false" (didDismiss)="onModalDismiss()"
             cssClass="ion-datetime-button-overlay">
    <ng-template>
      <div class="datetime-picker-wrapper">
        <div class="datetime-picker-header">
          <ion-button fill="clear" (click)="onCancelClick()">{{ 'SHARED_TEXT.CANCEL' | translate }}</ion-button>
          <ion-button fill="clear" (click)="onConfirmClick()"><strong>{{ 'SHARED_TEXT.DONE' | translate }}</strong></ion-button>
        </div>
        <ion-datetime
          presentation="time"
          [preferWheel]="true"
          hourCycle="h23"
          [ngClass]="{ error: isError }"
          [formControlName]="inputName"
          [id]="uniqueId"
        ></ion-datetime>
      </div>
    </ng-template>
  </ion-modal>
</ion-item>
